import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_02_Interface } from 'src/app/Interface/DataEntity/02/DataEntity_Detail_02_Interface';
import { DataEntity_Main_02_Interface } from 'src/app/Interface/DataEntity/02/DataEntity_Main_02_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity02ServiceService {

  constructor(private http: HttpClient) { }

  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno02/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_02_Interface,
    detail: Array<DataEntity_Detail_02_Interface>,
    DataEntity_id: number,
    Calibration_Id: number,
    Filename: string,
    FolderName: string,
    Capability: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    DELIVERY_TIME: Number,
    LabAddress_txt: String,

    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var detail_list = []
    var mesured_list = []


    var Indexer: number = 0
    for (let item of detail) {
      detail_list.push({
        id: item.id,
        main_id: model_temp.id,
        nominal: item.nominal,
        yb: item.yb+'',
        y: item.y + '',

        mpe_sys: item.mpe_sys,
        mpe_rnd: item.mpe_rnd,
        mpe_goal: item.mpe_goal,
        mpe_max: item.mpe_max,
        mpe_min: item.mpe_min,

        range_max: item.range_max,
        range_min: item.range_min,
        scale: item.scale,

        temperature_Water_before: item.temperature_Water_before,
        temperature_Water_after: item.temperature_Water_after,

        temperature_Air_before: item.temperature_Air_before,
        temperature_Air_after: item.temperature_Air_after,

        humidity_Air_before: item.humidity_Air_before,
        humidity_Air_after: item.humidity_Air_after,

        pressure_before: item.pressure_before,
        pressure_after: item.pressure_after,

        reference_Temperature: item.reference_Temperature+'',
        uncertainty: item.uncertainty,
        zfactor: item.zFactor+'',
        converage: item.converage,
        value: item.value,

        before: item.before,
      })

      for (let itemDetail of item.mesured) {
        mesured_list.push({
          main_id: Indexer,
          mesured: itemDetail+'',
        })
      }

      Indexer++
    }

    var model={
      id:model_temp.id,
      filename: Filename,
      pdf_src: FolderName,
      delivery_time: DELIVERY_TIME,
      manufacture: Manufacture_txt,
      type: Type_txt,
      model: Model_txt,
      capability: Capability,


      unit_nomimal: model_temp.unit_nomimal,
      unit_reference: model_temp.unit_reference,
      unit_correction: model_temp.unit_correction,
      unit_correction_eqution: model_temp.unit_correction_eqution,
      unit_uncertainy: model_temp.unit_uncertainy,
      unit_zfactor: model_temp.unit_zfactor,
    }

    var body = {
      Calibration_id: Calibration_Id,
      model: model,
      dataentity_id: DataEntity_id,
      detail: detail_list,
      mesured: mesured_list,
      Token: Token,
      labAdderss: LabAddress_txt,
    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno02/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno02/upload?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno02/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

}
